/* KŌSMOPELLIS — interactions premium légères */
(function () {
  'use strict';

  // Révélation au défilement
  function initReveal() {
    var els = document.querySelectorAll('.kp-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('kp-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('kp-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el, i) {
      el.style.transitionDelay = (Math.min(i % 4, 3) * 80) + 'ms';
      io.observe(el);
    });
  }

  // Filet de sécurité : tout révéler après 1,5s
  function safety() {
    setTimeout(function () {
      document.querySelectorAll('.kp-reveal:not(.kp-in)').forEach(function (el) {
        el.classList.add('kp-in');
      });
    }, 1500);
  }

  function init() { initReveal(); safety(); }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  // Ré-init dans l'éditeur de thème
  document.addEventListener('shopify:section:load', initReveal);
})();

/* Barre livraison offerte — maj client-side sur tout changement de panier */
(function () {
  function fmtEur(c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }
  function update(total) {
    document.querySelectorAll('[data-kp-shipbar]').forEach(function(bar){ updateBar(bar, total); });
  }
  function updateBar(bar, total) {
    if (!bar) return;
    var threshold = parseInt(bar.getAttribute('data-threshold'), 10) || 5900;
    var pct = Math.min(100, Math.round((total * 100) / threshold));
    var fill = bar.querySelector('.kp-shipbar__fill');
    var msg = bar.querySelector('.kp-shipbar__msg');
    var txt = bar.querySelector('.kp-shipbar__txt');
    if (fill) fill.style.width = pct + '%';
    if (total >= threshold) {
      bar.classList.add('is-done');
      if (msg) msg.classList.add('kp-shipbar__msg--done');
      if (txt) txt.innerHTML = 'Félicitations ! La <strong>livraison est offerte</strong>.';
    } else {
      bar.classList.remove('is-done');
      if (msg) msg.classList.remove('kp-shipbar__msg--done');
      if (txt) txt.innerHTML = 'Plus que <strong>' + fmtEur(threshold - total) + '</strong> pour la <strong>livraison offerte</strong> !';
    }
  }
  function refresh() {
    fetch((window.routes ? window.routes.cart_url : '/cart') + '.js', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (c) { update(c.total_price); })
      .catch(function () {});
  }
  document.addEventListener('DOMContentLoaded', function () {
    if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      subscribe(window.PUB_SUB_EVENTS.cartUpdate, refresh);
    }
  });
})();

/* Upsell panier — ajout d'un produit suggéré + re-render du drawer */
(function () {
  function addUpsell(btn) {
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;
    var drawer = document.querySelector('cart-drawer');
    var sections = (drawer && typeof drawer.getSectionsToRender === 'function')
      ? drawer.getSectionsToRender().map(function (s) { return s.id; }).join(',')
      : 'cart-drawer,cart-icon-bubble';
    btn.setAttribute('aria-busy', 'true');
    var addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';
    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: sections,
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) { btn.removeAttribute('aria-busy'); return; }
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents(data);
        }
        if (window.publish && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
          publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'kp-cart-upsell', productVariantId: variantId, cartData: data });
        }
      })
      .catch(function () { btn.removeAttribute('aria-busy'); });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-kp-upsell-add]') : null;
    if (btn) { e.preventDefault(); addUpsell(btn); }
  });
})();
